<template>
  <page>
    <template #content>
      <SubTopBar/>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" class="mb-n5">
            <v-combobox
              v-model="role"
              :items="items"
              label="Role *"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" class="mb-n5">
            <v-text-field
              outlined
              dense
              label="Organization name *"
              :rules="[global.rules.organisation]"
              v-model="invitee"/>
          </v-col>
          <v-col cols="12" class="mb-n5">
            <v-btn :disabled="!valid" color="primary" @click="invite">Invite Organization</v-btn>
            <v-btn text @click="close">cancel</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </page>
</template>

<script>
const Iam = require('iam')

export default {
  data() {
    return {
      role: "member",
      invitee: "",
      items: ["member", "owner"],
      valid: false
    }
  },
  computed: {
    organization: function () { return this.$route.params.organization },
    bcItems: function () {
      return [
        {},
        {
          text: "Organizations",
          disabled: false,
          exact: true,
          to: {name: 'Organizations'}
        },
        {
          text: `${this.$route.params.organization}`,
          disabled: false,
          exact: true,
          to: {name: 'OrganizationManagement'} 
          
        },
        {
          text: "Organizations",
          disabled: false,
          exact: true,
          to: {name: 'OrganizationOrganizations'} 
          
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  methods: {
    invite: function () {
      if (!this.$refs.form.validate()) {
        this.$refs.member.focus()
        return
      }
      if (this.role == "owner") {
        const body = new Iam.SetOrgOwner()
        body.orgowner = this.invitee
        this.$api.setOrgOwner(body, this.organization, this.callBack(this.close))
      } else {
        const body = new Iam.SetOrgMember()
        body.orgmember = this.invitee
        this.$api.setOrgMember(body, this.organization, this.callBack(this.close))
      }
    }
  }
}
</script>